import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

/**
 * TODOS
 *
 * 1. Analytics
 * 3. AB?
 * 4. Check for failures
 *
 */

const getVideoDomain = () => {
  if (!isBrowser()) return 'https://www.quince.com'
  if (window.location.origin.includes('localhost')) return 'https://www.quince.com' //TODO: Change to quince.com after going live
  return window.location.origin
}

const VIDEO_DESKTOP_SRC = `${getVideoDomain()}/abs-videos/TVC_hero_4/desktop-4k/tvc_desktop_text_4k.m3u8`
const VIDEO_MOBILE_SRC = `${getVideoDomain()}/abs-videos/TVC_hero_4/mobile-text-1080/tvc_mobile_text_1080p.m3u8`

// TODO-SSR: Before turing on this feature flag make sure the video from public/ssr-static/abs-videos directory is uploaded to CDN
export const SHOW_VIDEO_ON_HOME_PAGE = false

export const getVideoForDevice = (deviceType: DEVICE_TYPES) => {
  if (deviceType === DEVICE_TYPES.DESKTOP) return VIDEO_DESKTOP_SRC
  return VIDEO_MOBILE_SRC
}

export const getVideoPosterForDevice = (deviceType: DEVICE_TYPES) => {
  if (deviceType === DEVICE_TYPES.DESKTOP)
    return 'https://images.ctfassets.net/afruo3gr1g6h/51CdqV6IvQuLgJzjZezjvO/ccdc929745b9216f3e2ef092e647067d/Desktop_cover_text.png'
  return 'https://images.ctfassets.net/afruo3gr1g6h/2P6MitBmb9ESdssj2xuSX7/c469c73c78d36837f28b3084b6f3fce8/Mobile_still_withtext.png'
}

export const getIsShowVideo = (shouldShowOptimisedTheVideo = false) => {
  if (!shouldShowOptimisedTheVideo || !isBrowser()) return false
  return SHOW_VIDEO_ON_HOME_PAGE
}

export const getABSVideoProps = (shouldShowOptimisedTheVideo = false) => {
  if (!shouldShowOptimisedTheVideo) return {}
  return getIsShowVideo(shouldShowOptimisedTheVideo)
    ? {
        showVideo: shouldShowOptimisedTheVideo,
        videoSrc: {
          DESKTOP: VIDEO_DESKTOP_SRC,
          MOBILE: VIDEO_MOBILE_SRC,
        },
        transformScale: getTransformScale(),
      }
    : {}
}

export const getTransformScale = () => {
  return 'scale(1.01)'
}
